import type { TextHighlightColors } from '@/components/TextHighlight';

// TODO this should be extracted somewhere more sharable
export type TopicMenuGroupColor = {
  name: TextHighlightColors;
  bg: string;
  btn: string;
};

export function assignTopicMenuGroupColor(
  menuIndex: number | undefined,
): TopicMenuGroupColor {
  switch (menuIndex) {
    case 0:
      return {
        name: 'yellow',
        bg: 'bg-yellow-100 dark:bg-yellow-700',
        btn: 'bg-yellow-300',
      };
    case 1:
      return {
        name: 'magenta',
        bg: 'bg-magenta-100 dark:bg-magenta-700',
        btn: 'bg-magenta-300',
      };
    case 2:
      return {
        name: 'cyan',
        bg: 'bg-cyan-100 dark:bg-cyan-700',
        btn: 'bg-cyan-300',
      };
    case 3:
      return {
        name: 'green',
        bg: 'bg-green-100 dark:bg-green-700',
        btn: 'bg-green-300',
      };
    case 4:
      return {
        name: 'orange',
        bg: 'bg-orange-100 dark:bg-orange-700',
        btn: 'bg-orange-300',
      };
    case 5:
      return {
        name: 'purple',
        bg: 'bg-purple-100 dark:bg-purple-700',
        btn: 'bg-purple-300',
      };
    case 6:
      return {
        name: 'blue',
        bg: 'bg-blue-100 dark:bg-blue-700',
        btn: 'bg-blue-300',
      };
    default:
      return {
        name: 'yellow',
        bg: 'bg-yellow-100',
        btn: 'bg-yellow-300',
      };
  }
}
